import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { BuyerEntity } from "../dto/buyer-entity";


@Injectable()
export class BuyerRepo extends Repository<BuyerEntity> {

    constructor(@InjectRepository(BuyerEntity) private buyerRepo: Repository<BuyerEntity>
    ) {
        super(buyerRepo.target, buyerRepo.manager, buyerRepo.queryRunner);
    }

}